import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useState } from "react";

import { Close } from "@mui/icons-material";

import { useEnrollToCourseTurma } from "../../api/enrollToCourseTurma";
import { createNotification } from "../../../../shared/store/notifications";

const CancelEnrollment = ({ course, children }) => {
  const courseId = course.disciplinaid;

  const enrollMutation = useEnrollToCourseTurma({ courseId });
  const [dialogOpen, setDialogOpen] = useState(false);
  const methods = {
    openDialog: () => {
      setDialogOpen(true);
    },
    closeDialog: () => {
      setDialogOpen(false);
    },
  };
  const handleConfirm = () => {
    enrollMutation.mutate(
      { turmaId: 0, courseId },
      {
        onSuccess: () => {
          methods.closeDialog();
          createNotification({ type: "info", message: "Matrícula cancelada" });
        },
      }
    );
  };

  return (
    <>
      {children(methods)}

      <Dialog open={dialogOpen} maxWidth="sm" fullWidth>
        <IconButton
          sx={{ position: "absolute", top: 3, right: 3 }}
          onClick={methods.closeDialog}
        >
          <Close />
        </IconButton>
        <DialogTitle>Cancelar matrícula</DialogTitle>

        <DialogContent>
          <DialogContentText>
            Você tem certeza que deseja cancelar sua matrícula?
          </DialogContentText>
          <DialogActions>
            <Button onClick={handleConfirm}>Sim </Button>
            <Button onClick={methods.closeDialog} variant="contained">
              {" "}
              Não{" "}
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CancelEnrollment;
